export default __webpack_public_path__ + "static/monetisation-f7066f0edbab5e6d5fd8b5ab6f340a13.png";